<template>
  <div class="label_component">
    <div class="left_right_icon left" @click="toLeft">
      <a-icon type="left" style="color: #2CBD9C" />
    </div>
    <div class="content_box" ref="labelComponent">
      <ul
        class="all_label_box"
        ref="allLabelBox"
        :style="{ left: `${left}px` }"
      >
        <li
          class="label_box"
          v-for="label in value"
          :key="label"
          :class="{ select: current === label || currentName === label }"
          @click="onclick(label)"
        >
          <span>{{ getLabelTitle(label) }}</span>
          <!-- v-if="label !== 'orderList'" -->
          <a-icon
            type="close"
            @click.stop="onRemove(label)"
          />
        </li>
      </ul>
    </div>
    <div class="left_right_icon right" @click="toRight">
      <a-icon type="right" style="color: #2CBD9C" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Label",
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    current: {
      type: String,
      default: "",
    },
    currentName: {
      type: String,
      default: "",
    },
    labelToName: {
      type: Object,
      default: () => {
        return {};
      },
    },
    left: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      labelComponentWidth: 0,
      allLabelBoxWidth: 0,
    };
  },
  created() {},
  mounted() {
    this.getCompoentWidth();
  },
  methods: {
    getLabelTitle(label) {
      // 优先使用 labelToName 映射
      if (this.labelToName[label]) return this.labelToName[label]
      return label
    },
    getCompoentWidth() {
      this.labelComponentWidth = this.$refs.labelComponent.offsetWidth;
      this.allLabelBoxWidth = this.$refs.allLabelBox.offsetWidth;
    },
    onclick(routerName) {
      this.$emit("click", routerName);
    },
    onRemove(routerName) {
      this.$emit("onRemove", routerName);
    },
    toLeft() {
      this.getCompoentWidth();
      const difference = this.allLabelBoxWidth - this.labelComponentWidth;
      if (difference > 0) {
        let left = this.left - 150;
        if (Math.abs(left) > difference) {
          left = -difference;
        }
        this.$emit("update:left", left);
      }
    },
    toRight() {
      this.getCompoentWidth();
      const difference = this.allLabelBoxWidth - this.labelComponentWidth;
      if (difference > 0) {
        let left = this.left + 150;
        if (left > 0) {
          left = 0;
        }
        this.$emit("update:left", left);
      }
    },
  },
  watch: {},
};
</script>

<style lang="less">
.label_component {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  .left_right_icon {
    width: 30px;
    height: 100%;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }

    .anticon {
      line-height: 43px;
    }

    &.left {
      position: absolute;
      left: 0;
      top: 0;
    }

    &.right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .content_box {
    position: absolute;
    left: 30px;
    right: 30px;
    top: 0;
    bottom: 0;
    height: 100%;
    overflow: hidden;

    .all_label_box {
      height: 100%;
      white-space: nowrap;
      display: inline-flex;
      transition: all 0.3s;
      position: absolute;
      top: 0;

      .label_box {
        float: left;
        width: auto;
        height: 100%;
        position: relative;
        line-height: 43px;
        cursor: pointer;
        color: #333333;
        font-size: 14px;
        padding: 0 20px !important;

        .anticon {
          position: absolute;
          right: 1px;
          top: 15px;
          color: #2CBD9C;
          opacity: 0;
          font-size: 12px;
          transition: all 0.3s;
        }

        &:hover {
          color: #2CBD9C;

          .anticon {
            opacity: 1;
          }
        }

        &.select {
          color: #2CBD9C;
          border-bottom: 2px solid #2CBD9C;
        }
      }

      &::after {
        content: " ";
        display: block;
        height: 0;
        font-size: 0;
      }
    }
  }
}
</style>